/*************************************************************************
 * Copyright (C) IBS Software 2022
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **************************************************************************/
 import timeZoneCityToCountry from "./assests/cityCountryList.json";
 import countryCity from "./assests/countryCode.json";

 var mp_analytics_configuration = {};
 import { JSONPath } from "jsonpath-plus";
 import moment from 'moment'
 
 
 /** Function to initialize the configuration */
 const initConfiguration = (key, config) => {
   mp_analytics_configuration[key] = config;
 };
 
 /** Function to Create the Object which needs to push to data layer */
 const pushEvent = async (type, id=undefined, data, customFunction=undefined) => {
   /** config - configuration */
   /** type - element type */
   /** id - element id */
   /** data -  state data */
   /** customFunction - customFunction (optional) */
 
   /** Need to traverse through configuration  and push the object into dataLayer */
   try {
     Object.keys(mp_analytics_configuration).forEach((key) => {
       let _config = mp_analytics_configuration[key][id]
         ? mp_analytics_configuration[key][id]
         : mp_analytics_configuration[key][type]
         ? mp_analytics_configuration[key][type]
         : undefined;
       let _data = constructData(
         getMapping(key, _config),
         {
           ...data,
           _config: mp_analytics_configuration[key],
         },
         customFunction
       );
       if (_data && Object.keys(_data).length > 0) {
         const dataAnalyticsVariable =
           mp_analytics_configuration[key] &&
           mp_analytics_configuration[key]._data_analytics_variable
             ? mp_analytics_configuration[key]._data_analytics_variable
             : "dataLayer";
         Object.keys(_data).map((item) => {
          if(Array.isArray(window[dataAnalyticsVariable]) ){
             window[dataAnalyticsVariable].push(_data[item])
           } else {
            if(window[dataAnalyticsVariable] && window[dataAnalyticsVariable].event && 
              window[dataAnalyticsVariable].event.length > 0) {
                window[dataAnalyticsVariable]["page"] = _data[item]["page"];
                window[dataAnalyticsVariable]["user"] = _data[item]["user"];
                window[dataAnalyticsVariable].event.push(_data[item]["event"]);
             
            } else {
              // window[dataAnalyticsVariable] = {};
              // window[dataAnalyticsVariable]["event"] = [];
              window[dataAnalyticsVariable]["page"] = _data[item]["page"];
              window[dataAnalyticsVariable]["user"] = _data[item]["user"];
              window[dataAnalyticsVariable]["event"].push(_data[item]["event"])
            }
            
          //    window[dataAnalyticsVariable] = {
          //      ... window[dataAnalyticsVariable],
          //      ..._data[item]
          //  };
          // window[dataAnalyticsVariable] =_data[item]
          //  console.log("1",  window[dataAnalyticsVariable])
           }
         
         });
       }
     });
   } catch (err) {
     console.error(err, "Analytics Error!");
   }
 };
 
 const getMapping = (key, config, mappings = []) => {
   if (config) {
     if (config["_mapping"]) mappings = mappings.concat(config["_mapping"]);
     if (config["_base"] && mp_analytics_configuration[key][config["_base"]]) {
       return getMapping(
         key,
         mp_analytics_configuration[key][config["_base"]],
         mappings
       );
     }
   }
   return mappings;
 };
 
 const handleMapping = (item, data, _object, customFunction) => {
   let value = "";
   if(item.from_path == "timeStamp") {
    let date = moment.unix(Date.now()/1000);
    value = moment(date).format();
   } else if (item.custom && customFunction[item.custom]) {
     value = customFunction[item.custom](item, data);
   } else if (Array.isArray(item.from_path)) {
     let temp = "";
     item.from_path.map((pathValue) => {
       temp = JSONPath({
         path: pathValue,
         json: { ...data, window },
       })[0];
       if (!isEmptyOrSpaces(temp) || item.ignoreEmptyCheck) {
         value = value ? value + item.delimiter + temp : value + temp;
       }
     });
   } else {
     value = JSONPath({
       path: item.from_path,
       json: { ...data, window },
     })[0];
   }
 
   if (!isEmptyOrSpaces(value) || item.ignoreEmptyCheck) {
     setValueToObjectByPath(item.to_path, value, _object);
   }
 };
 const checkValidPattern = (item, json) => {
   let { patterns, expression } = item;
   if (item.enabled) {
     patterns.forEach((obj) => {
       const { pattern, key, defaultVal } = obj;
       const value = JSONPath({ path: pattern, json });
       expression = expression.replace(
         key,
         value.length > 0 ? value[0] : defaultVal
       );
     });
   }
   return !eval(expression);
 };
 const constructData = (mappings, data, customFunction) => {
   let _object = {};
   mappings.map((item) => {
     if (item.enabled) {
       let conditionValue = true;
       /** Code for checking condition */
       if (item.conditions && item.conditions.length) {
         item.conditions.forEach((value) => {
           conditionValue = conditionValue && checkValidPattern(value, data);
         });
       }
       if (conditionValue) {
         handleMapping(item, data, _object, customFunction);
       }
     }
   });
   return _object;
 };
 
 const isEmptyOrSpaces = (str) => {
   return (
     str === null ||
     str === "null" ||
     str === undefined ||
     str === "undefined" ||
     (typeof str === "string" && str.match(/^ *$/) !== null)
   );
 };
 const setValueToObjectByPath = (pList, value, schema) => {
   if (pList && !isEmptyOrSpaces(pList)) {
     pList = pList.split(".");
     var len = pList.length;
     for (var i = 0; i < len - 1; i++) {
       var elem = pList[i];
       if (!isNaN(elem)) {
         elem = parseInt(elem);
         if (pList.length > i + 1) {
           for (let k = 0; k <= elem; k++) {
             if (!schema[k]) {
               schema.push({});
             }
           }
           schema = schema[elem];
         }
       } else {
         if (!schema[elem]) {
           if (pList.length > i + 1 && !isNaN(pList[i + 1])) {
             schema[elem] = [];
           } else {
             schema[elem] = {};
           }
         }
         schema = schema[elem];
       }
     }
     schema[pList[len - 1]] = value;
   }
 };



export const getCountryNameFromTimeZone = () => {
  let userTimeZone, userRegion, userCity, userCountry;
  if (Intl) {
      userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let tzArr = userTimeZone.split("/");
      userRegion = tzArr[0];
      userCity = tzArr[tzArr.length - 1];
      userCountry = timeZoneCityToCountry[userCity];
      window.userCountryCode = countryCity[userCountry];
  }
}
 const getPageName = () => {
    let dataArray = ["https://", "http://", "www.", ".com", "#"];
    let url = window.location.href;
    const urlObj = new URL(url);
    urlObj.search = '';
    url= urlObj.toString();
    dataArray.map(item => {
      url = url.replaceAll(item, "");
    })
    url = url.replaceAll("//", "/");
    url = url.replaceAll("/", ":")
    return url;
 }
const siteSubSections = (subSection) => {
  let url = getPageName();
  switch(subSection) {
    case "siteSubSection1":
      return url? (url.split(":")[1]?  url.split(":")[1]: "" ) : "";
    case "siteSubSection2":
      return url? (url.split(":")[2]?  url.split(":")[2]: "" ) : "";
    case "siteSubSection3":
      return url? (url.split(":")[3]?  url.split(":")[3]: "" ) : "";
    case "siteSubSection4":
      return url? (url.split(":")[4]?  url.split(":")[4]: "" ) : "";
    case "siteSubSection4":
      return url? (url.split(":")[5]?  url.split(":")[5]: "" ) : "";
  }
}
  const getHeirachy = () => {
    let url = getPageName();
    let value = url.split(":");
    if(value && value.length) {
      value.shift();
      value = value.join(":")
      
    }
    return value? value: "";
 }

 const psAnalytics = { pushEvent, initConfiguration, getCountryNameFromTimeZone };
 export default psAnalytics;
 